import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function ChangeFirstPassword() {
  const { t } = useTranslation();
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");
  const [show, setShow] = useState(false);
  const [msg, setMsg] = useState("");

  async function submit(e) {
    e.preventDefault();

    setMsg("");

    const token = localStorage.getItem("membreToken");

    if (!token) {
      setMsg(t("changeFirstPassword.errors.sessionExpired"));
      return;
    }

    if (p1.length < 6) {
      setMsg(t("changeFirstPassword.errors.tooShort"));
      return;
    }

    if (p1 !== p2) {
      setMsg(t("changeFirstPassword.errors.mismatch"));
      return;
    }

    setMsg("");

    try {
      const res = await fetch("/api/membre?action=changeFirst", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          newPassword: p1,
        }),
      });

      const data = await res.json();

      if (data.success) {
        window.location.href = "/membre/dashboard";
        return;
      }

      if (res.status === 401 || res.status === 403) {
        localStorage.removeItem("membreToken");
        localStorage.removeItem("membre");

        setMsg(data.message || t("changeFirstPassword.errors.invalidSession"));

        return;
      }

      setMsg(data.message || t("changeFirstPassword.errors.server"));
    } catch (error) {
      console.error("CHANGE FIRST PASSWORD ERROR:", error);
      setMsg(t("changeFirstPassword.errors.network"));
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-5 bg-gradient-to-r from-slate-900 via-slate-800 to-indigo-800">
      <div className="bg-white/95 rounded-3xl shadow-2xl p-8 w-full max-w-md">
        <h1 className="text-2xl font-extrabold text-center text-slate-900">
  {t("changeFirstPassword.title")}
</h1>

<p className="text-slate-600 text-center text-sm mt-1">
  {t("changeFirstPassword.description")}
</p>

        <form onSubmit={submit} className="space-y-4 mt-6" method="POST">
          <div className="relative">
            <input
              type={show ? "text" : "password"}
              placeholder={t("changeFirstPassword.newPassword")}
              value={p1}
              onChange={(e) => setP1(e.target.value)}
              className="w-full px-4 py-3 bg-slate-50 border border-slate-300 rounded-xl focus:ring-2 focus:ring-indigo-500"
            />
            <button
              type="button"
              className="absolute right-3 top-3"
              onClick={() => setShow(!show)}
            >
              {show ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          <input
            type={show ? "text" : "password"}
            placeholder={t("changeFirstPassword.confirmPassword")}
            value={p2}
            onChange={(e) => setP2(e.target.value)}
            className="w-full px-4 py-3 bg-slate-50 border border-slate-300 rounded-xl focus:ring-2 focus:ring-indigo-500"
          />

          {msg && <p className="text-red-600 text-center">{msg}</p>}

          <button className="w-full py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-xl">
            {t("changeFirstPassword.submit")}
          </button>
        </form>
      </div>
    </div>
  );
}
